import React from 'react';
import { Dialog, Drawer } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const styles = {
  drawerPaper: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    bgcolor: 'background.paper',
  },
  dialogPaper: {
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    bgcolor: 'background.paper',
  },
};

export default function BaseModal({
  open,
  onClose,
  children,
  drawerHeight = 'calc(100dvh - 72px)',
  dialogMaxWidth = 'sm',
  dialogWidth = 650,
  dialogHeight = '88vh',
  bgcolor = 'background.paper',
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          ...styles.drawerPaper,
          bgcolor,
          ...(drawerHeight !== 'auto' && { height: drawerHeight, maxHeight: drawerHeight }),
        },
      }}
    >
      {children}
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={dialogMaxWidth}
      fullWidth
      PaperProps={{
        sx: {
          ...styles.dialogPaper,
          bgcolor,
          ...(dialogHeight !== 'auto' && { height: dialogHeight, maxHeight: dialogHeight }),
          width: { sm: '90vw', md: `${dialogWidth}px` },
          maxWidth: { sm: '90vw', md: `${dialogWidth}px` },
        },
      }}
    >
      {children}
    </Dialog>
  );
}
